import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { useModalHook } from "../useModal";

/**
 * Asks before taking a redeemed offer out of the cart: the offer's own popup in
 * its applied state, which carries the service's "remove" copy and only
 * removes on Remove — Keep leaves the cart as it is.
 */
export const useConfirmOfferRemoval = () => {
  const { handleModal } = useModalHook();

  return (offer: LoyaltyOffer) =>
    handleModal(true, "LoyaltyRedeemPopup/LoyaltyRedeemPopup", {
      componentProps: { offer, isActiveOffer: true },
    });
};
